import { createSelector } from 'reselect';
import { AppState } from '../../types';
import { WatchHistory } from './types';
import { SearchUser } from '@fullstory/proto/fs/services/alexa';

const getLocal = (state: AppState) => state.watchHistory.local;
const getFetched = (state: AppState) => state.watchHistory.fetched;

export const watchHistory = createSelector(getLocal, getFetched, (local, fetched) => {
  const { data, ...rest } = fetched;
  return {
    ...rest,
    data: {
      ...data?.reduce(
        (obj, item) => ({
          ...obj,
          [item]: true,
        }),
        {},
      ),
      ...local,
    } as WatchHistory,
  };
});

export const hasBeenWatched = (watchHistory: WatchHistory, user: SearchUser): boolean => {
  const key = `${user.indvId}:${user.lastMatchingUserSessionId}`;
  return watchHistory?.[key] ?? false;
};
